import * as z from 'zod';

export const saleQueryParamsSchema = z.object({
  edit: z.boolean().optional(),
  date: z.boolean().optional(),
  forceEdit: z.boolean().optional(),
  name: z.string().optional(),
  p: z.string().optional(),
});

export type SaleQueryParams = z.infer<typeof saleQueryParamsSchema>;
